<script>
import MixedGridFiltersItemList from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemList';
import Fragment from '@phoenix/components/common/Fragment.vue';

export default {
  mixins: [MixedGridFiltersItemList],

  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['onItemSelected'],

  computed: {
    listComponent() {
      return this.isMobile ? Fragment : 'li';
    },

    containerComponent() {
      return this.isMobile ? 'div' : 'ul';
    },

    containerClasses() {
      return this.isMobile ? 'container container--md pt-2 sm:pt-4 pb-5' : 'collapse__body p-4 pt-2';
    },
  },

  methods: {
    getCheckboxClasses(item) {
      return [
        'checkbox',
        {
          'checkbox--disabled': item.disabled,
          flex: this.isMobile,
        },
      ];
    },

    getInputId(item) {
      return `filtersub-${this.isMobile ? 'mobile' : 'desktop'}-${this.filter.id}-${item.value}`;
    },
  },
};
</script>

<template>
  <component
    :is="containerComponent"
    :class="containerClasses"
    data-cy="mixed-grid-filter-list"
    :data-cy-filter-id="filter.id"
  >
    <component :is="listComponent" v-for="item in filter.items" :key="item.value">
      <div :class="getCheckboxClasses(item)">
        <input
          :id="getInputId(item)"
          :data-property="filter.id"
          :data-value="item.value"
          type="checkbox"
          :disabled="item.disabled && item.disabled === true"
          :name="getInputId(item)"
          :checked="itemIsActive(item)"
          :value="item.value"
          class="checkbox__input"
          @change="$emit('onItemSelected', filter.id, item.value)"
        />
        <label :for="getInputId(item)" class="checkbox__label">{{ item.label }}</label>
      </div>
    </component>
  </component>
</template>
